import Header from "components/Headers/Header";
import TableComponent from "components/TableComponent";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import { fetchUserStats } from "store/actions/additionalEarningAction";
import { fetchCoinsStats } from "store/actions/additionalEarningAction";

const Crypto = () => {
  const { userStats, transactions } = useSelector((state) => state.earnings);
  const [filter, setFilter] = useState({
    id: "",
    startDate: "",
    endDate: "",
  });

  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [columns, setColumns] = useState([]);
  const [keyMaps, setKeyMaps] = useState({});
  const [loadingStats, setLoadingStats] = useState(false);

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  useEffect(() => {
    const role = transactions?.length ? transactions[0].role : "";

    switch (role) {
      case "fan":
      case "vendor":
        setColumns([
          "Username",
          "Amount Spent",
          "Coins Distributed",
          "Spent On",
          "created At",
        ]);
        setKeyMaps({
          Username: "name",
          "Amount Spent": "amount",
          "Coins Distributed": "distributedCoins",
          "Spent On": "type",
          "created At": "createdAt",
        });
        break;

      case "manager":
        setColumns([
          "Username",
          "Earned Amount",
          "Coins Distributed",
          "Earned From",
          "created At",
        ]);
        setKeyMaps({
          Username: "name",
          "Earned Amount": "amount",
          "Coins Distributed": "distributedCoins",
          "Earned From": "type",
          "created At": "createdAt",
        });
        break;

      default:
        setColumns([
          "Username",
          "Amount Spent",
          "Coins Distributed",
          "Spent On",
          "created At",
        ]);
        setKeyMaps({
          Username: "name",
          "Amount Spent": "amount",
          "Coins Distributed": "distributedCoins",
          "Spent On": "type",
          "created At": "createdAt",
        });
    }
  }, [transactions]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilter((prev) => ({ ...prev, [name]: value }));
  };

  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!filter.id) {
      toast.warning("User ID is required.");
      return;
    }

    if (
      (filter.startDate && !filter.endDate) ||
      (!filter.startDate && filter.endDate)
    ) {
      toast.warning("Both start and end dates are required if one is filled.");
      return;
    }

    const formatDateForFilter = (date) => {
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${day}-${month}-${year}`;
    };

    const updatedFilter = {
      ...filter,
      startDate: filter.startDate ? formatDateForFilter(filter.startDate) : "",
      endDate: filter.endDate ? formatDateForFilter(filter.endDate) : "",
    };

    setLoading(true);
    dispatch(
      fetchCoinsStats(updatedFilter, () => {
        setLoading(false);
      })
    );
  };

  const handleClearFilter = () => {
    setFilter({ id: "", startDate: "", endDate: "" });
  };

  const summaryColumns = ["", "Fans", "Managers", "Vendors"];

  const summaryKeyMap = {
    "": "label",
    Fans: "fans",
    Managers: "managers",
    Vendors: "vendors",
  };

  const formattedTransactions =
    transactions.length > 0
      ? transactions.map((item) => ({
          ...item,
          createdAt: formatDate(item.createdAt),
        }))
      : [Object.fromEntries(Object.values(keyMaps).map((key) => [key, "N/A"]))];

  useEffect(() => {
    setLoadingStats(true);
    dispatch(
      fetchUserStats(String(selectedYear), () => {
        setLoadingStats(false);
      })
    );
  }, [selectedYear]);

  return (
    <>
      <Header />
      <Container fluid className="mb-5">
        <Row className="mb-3">
          <Col sm="6" md="4">
            <FormGroup>
              <Label for="year">Select Year</Label>
              <Input
                type="select"
                name="year"
                id="year"
                value={selectedYear}
                onChange={handleYearChange}
              >
                <option value={new Date().getFullYear()}>
                  {new Date().getFullYear()}
                </option>
                <option value={new Date().getFullYear() - 1}>
                  {new Date().getFullYear() - 1}
                </option>
                <option value={new Date().getFullYear() - 2}>
                  {new Date().getFullYear() - 2}
                </option>
              </Input>
            </FormGroup>
          </Col>
        </Row>
        <h5>Users Signed Up for Free Crypto</h5>
        <Card className="p-3 mb-4">
          {loadingStats ? (
            <div className="text-center">
              <Spinner color="primary" />
            </div>
          ) : (
            <Table borderless responsive className="text-center mb-0">
              <thead>
                <tr>
                  {summaryColumns.map((column, index) => (
                    <th
                      scope="col"
                      key={index}
                      className="custom-table-heading custom-heading "
                    >
                      {column}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="custom-table-body mt-3">
                {(userStats && userStats.length > 0 ? userStats : [{}]).map(
                  (item, index) => (
                    <>
                      <tr>
                        <td>#</td>
                        <td className="custom-table-text truncated-text">
                          {item?.fans || 0}
                        </td>
                        <td className="custom-table-text truncated-text">
                          {item?.managers || 0}
                        </td>
                        <td className="custom-table-text truncated-text">
                          {item?.vendor || 0}
                        </td>
                      </tr>
                      <tr>
                        <td>Tokens Given</td>
                        <td className="custom-table-text truncated-text">
                          {Number(item?.distributedCoinsToFans || 0).toFixed(2)}
                        </td>
                        <td className="custom-table-text truncated-text">
                          {Number(
                            item?.distributedCoinsToManagers || 0
                          ).toFixed(2)}
                        </td>
                        <td className="custom-table-text truncated-text">
                          {Number(item?.distributedCoinsToVendors || 0).toFixed(
                            2
                          )}
                        </td>
                      </tr>
                    </>
                  )
                )}
              </tbody>
            </Table>
          )}
        </Card>

        <Card className="px-4 pt-3 mb-4">
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col sm="6" md="4">
                <FormGroup>
                  <Label for="id">User ID</Label>
                  <Input
                    type="text"
                    name="id"
                    id="id"
                    placeholder="#ID : 1000190"
                    value={filter.id}
                    onChange={handleChange}
                  />
                </FormGroup>
              </Col>
              <Col sm="6" md="4">
                <FormGroup>
                  <Label for="startDate">Start Date</Label>
                  <Input
                    type="date"
                    name="startDate"
                    id="startDate"
                    value={filter.startDate}
                    onChange={handleChange}
                  />
                </FormGroup>
              </Col>
              <Col sm="6" md="4">
                <FormGroup>
                  <Label for="endDate">End Date</Label>
                  <Input
                    type="date"
                    name="endDate"
                    id="endDate"
                    value={filter.endDate}
                    onChange={handleChange}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col lg="12" className="text-right pb-4">
                <div className="d-flex flex-column flex-sm-row justify-content-sm-end">
                  <Button
                    color="danger"
                    className="mb-2 mb-sm-0 mr-0 mr-sm-2 ml-0 ml-sm-2"
                    onClick={handleClearFilter}
                  >
                    Clear Filters
                  </Button>
                  <Button
                    type="submit"
                    className="ml-0 ml-sm-2"
                    color="primary"
                    disabled={loading}
                  >
                    {loading ? <Spinner size="sm" /> : "Apply Filters"}
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </Card>

        <Card className="p-2">
          <TableComponent
            columns={columns}
            data={formattedTransactions}
            keyMap={keyMaps}
          />
        </Card>
      </Container>
    </>
  );
};

export default Crypto;
